export const FLEET_MODAL_BULK_OUTPUTS_OPEN = 'FLEET_MODAL_BULK_OUTPUTS_OPEN';

export const FLEET_MODAL_BULK_OUTPUTS_SEND_COMMAND = 'FLEET_MODAL_BULK_OUTPUTS_SEND_COMMAND';
export const FLEET_MODAL_BULK_OUTPUTS_SEND_COMMAND_RESULT = 'FLEET_MODAL_BULK_OUTPUTS_SEND_COMMAND_RESULT';

export const FLEET_MODAL_BULK_OUTPUTS_GET_OUTPUTS = 'FLEET_MODAL_BULK_OUTPUTS_GET_OUTPUTS';
export const FLEET_MODAL_BULK_OUTPUTS_GET_OUTPUTS_RESULT = 'FLEET_MODAL_BULK_OUTPUTS_GET_OUTPUTS_RESULT';
